var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.284,
    height: 11.463,
    viewBox: "0 0 15.284 11.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-envelope",
    "data-name": "Icon awesome-envelope",
    d: "M14.994,8.285a.18.18,0,0,1,.29.14v6.1a1.433,1.433,0,0,1-1.433,1.433H1.433A1.433,1.433,0,0,1,0,14.53v-6.1a.179.179,0,0,1,.29-.14c.669.519,1.555,1.179,4.6,3.391.63.46,1.693,1.427,2.752,1.421s2.149-.979,2.755-1.421C13.442,9.467,14.326,8.8,14.994,8.285ZM7.642,12.142c.693.012,1.69-.872,2.191-1.236,3.961-2.875,4.263-3.125,5.176-3.842a.714.714,0,0,0,.275-.564V5.933A1.433,1.433,0,0,0,13.851,4.5H1.433A1.433,1.433,0,0,0,0,5.933V6.5a.719.719,0,0,0,.275.564c.913.713,1.215.967,5.176,3.842C5.952,11.27,6.949,12.154,7.642,12.142Z",
    transform: "translate(0 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.3dda325f79e5b6bf1cc1dbbb783940c2.svg";
export { ForwardRef as ReactComponent };